import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { PROGRAMMES } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/structure/programmes/new")({
  component: () => <DeptContentForm cfg={PROGRAMMES} />,
});
